"use client";

import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import ModalTemplate from "@/components/molecules/modal-template";
import InspirationSingleWrapper from "@/components/organisms/inspiration-single-wrapper";
import { Locales } from "@/lib/i18n";
import { _x } from "@/lib/i18n/functions";
import { InspirationsWithProducts } from "@/types";

type InspirationModalManagerProps = {
  locale: Locales;
  inspirations: InspirationsWithProducts[];
};

const InspirationModalManager = ({ locale, inspirations }: InspirationModalManagerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentHash, setCurrentHash] = useState("");

  const params = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const handleClose = () => router.push(pathname, { scroll: false });

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    setCurrentHash(hash);

    if (hash) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [params]);

  const inspiration = inspirations.find((insp) => insp.uid === currentHash);

  if (!inspiration || !inspiration.data) return null;

  const inspirationTitle = inspiration.data.title as string;

  return (
    <ModalTemplate
      key={inspiration.id}
      title={_x("See Inspiration : {{ inspirationTitle }}", { inspirationTitle }, locale)}
      className="w-full max-w-none overflow-hidden sm:max-w-[1349px]"
      classNameTitle="sr-only"
      classNameHeader="md:mb-0 mb-0 px-0 pt-0 md:pt-0"
      open={isOpen}
      hideScrollAreaOnMobile
      onOpenChange={(open) => {
        if (!open) {
          handleClose();
          setCurrentHash("");
        }
      }}
    >
      <InspirationSingleWrapper locale={locale} inspiration={inspiration} products={inspiration.resolvedProducts} />
    </ModalTemplate>
  );
};

export default InspirationModalManager;
